import React from 'react';
import PropTypes from "prop-types";

const ClientsThumb = ({images}) => {
    return (
        <div className="portfolio-details-image mb-sm-30 mb-xs-30">
            {images && images.map((image, index) => (
                <img key={index} src={require('../../assets/images/clients/' + image)}/>
            ))}
        </div>
    );
};

ClientsThumb.propsType = {
    images: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
};

export default ClientsThumb;